const tipoAtos = [
  {
    codigo: 'CE',
    descricao: 'Certidões',
    codigosCusta: [9, 10, 150],
    tipo_registro: 'todos'
  },
  {
    codigo: 'EP',
    descricao: 'Afixação de Editais de Proclamas',
    codigosCusta: [6],
    tipo_registro: 'habilitacao'
  },
  {
    codigo: 'AC',
    descricao: 'Assento(Termo) de Casamento',
    codigosCusta: [4, 5, 18],
    tipo_registro: 'casamento'
  },
  {
    codigo: 'AN',
    descricao: 'Assento(Termo) de Nascimento',
    codigosCusta: [16, 158, 159],
    tipo_registro: 'nascimento'
  },
  {
    codigo: 'AO',
    descricao: 'Assento(Termo) de Óbito',
    codigosCusta: [16],
    tipo_registro: 'obito'
  },
  {
    codigo: 'NT',
    descricao: 'Assento(Termo) de Natimorto',
    codigosCusta: [16],
    tipo_registro: 'natimorto'
  },
  {
    codigo: 'LC',
    descricao: 'Autenticação de Livro Mercantil',
    codigosCusta: [162],
    tipo_registro: 'todos'
  },
  {
    codigo: 'LE',
    descricao: 'Demais Registros (Livro E)',
    codigosCusta: [7],
    tipo_registro: 'livro_e'
  },
  {
    codigo: 'AV',
    descricao: 'Averbação em Geral',
    codigosCusta: [8],
    tipo_registro: 'todos'
  },
  {
    codigo: 'DD',
    descricao: 'Cópia de Microfilme ou Documento Desentranhado',
    codigosCusta: [14],
    tipo_registro: 'todos'
  },
  {
    codigo: 'CR',
    descricao: 'Cópia Reprográfica de Atos Praticados e Documentos Arquivados na Serventia',
    codigosCusta: [13],
    tipo_registro: 'todos'
  },
  {
    codigo: 'IV',
    descricao: 'Informação Verbal quando dispensada a Certidão',
    codigosCusta: [11],
    tipo_registro: 'todos'
  },
  {
    codigo: 'PC',
    descricao: 'Procedimentos em Geral',
    codigosCusta: [15],
    tipo_registro: 'todos'
  },
  {
    codigo: 'AP',
    descricao: 'Apostilamento',
    codigosCusta: [161],
    tipo_registro: 'todos'
  },
  {
    codigo: 'PV',
    descricao: '1ª Via de Certidão em Cumprimento do Ato',
    codigosCusta: [4, 5, 7, 16, 17],
    tipo_registro: 'todos'
  },
  {
    codigo: 'HC',
    descricao: 'Habilitação de Casamento',
    codigosCusta: [1, 2, 3],
    tipo_registro: 'habilitacao'
  },
  {
    codigo: 'XX',
    descricao: 'Ato de Serventia Extrajudicial de outro Estado',
    codigosCusta: [],
    tipo_registro: 'todos'
  },
  {
    codigo: 'XC',
    descricao: 'Cancelamento do Ato',
    codigosCusta: [],
    tipo_registro: 'todos'
  },
  {
    codigo: 'XA',
    descricao: 'Exclusão do Ato',
    codigosCusta: [],
    tipo_registro: 'todos'
  },
  {
    codigo: 'ES',
    descricao: 'Escrituras',
    codigosCusta: [101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 127, 128, 129, 130, 131, 132, 133, 134, 135, 151, 152, 160],
    tipo_registro: 'escrituras'
  },
  {
    codigo: 'PR',
    descricao: 'Procurações',
    codigosCusta: [136, 137, 138, 139, 140, 141, 142, 143],
    tipo_registro: 'procuracao'
  },
  {
    codigo: 'AU',
    descricao: 'Autenticações',
    codigosCusta: [144],
    tipo_registro: 'autenticacao'
  },
  {
    codigo: 'S1',
    descricao: 'Firma 1 sem Valor Econômico',
    codigosCusta: [145],
    tipo_registro: 'firmas'
  },
  {
    codigo: 'S2',
    descricao: 'Firma 2 sem Valor Econômico',
    codigosCusta: [146],
    tipo_registro: 'firmas'
  },
  {
    codigo: 'C1',
    descricao: 'Firma 1 com Valor Econômico',
    codigosCusta: [147],
    tipo_registro: 'firmas'
  },
  {
    codigo: 'C2',
    descricao: 'Firma 2 com Valor Econômico',
    codigosCusta: [148],
    tipo_registro: 'firmas'
  },
  {
    codigo: 'RA',
    descricao: 'Reconhecimento de Firma por Autenticidade',
    codigosCusta: [149],
    tipo_registro: 'firmas'
  },
  {
    codigo: 'CM',
    descricao: 'Chancela Mecânica',
    codigosCusta: [153],
    tipo_registro: 'todos'
  },
  {
    codigo: 'TE',
    descricao: 'Testamentos',
    codigosCusta: [154, 155, 156, 157],
    tipo_registro: 'testamentos'
  },
  {
    codigo: 'TR',
    descricao: 'Traslados',
    codigosCusta: [165],
    tipo_registro: 'todos'
  },
  {
    codigo: 'UE',
    descricao: 'TERMO DECLARATÓRIO DE RECONHECIMENTO E DE DISSOLUÇÃO DE UNIÃO ESTÁVEL',
    codigosCusta: [20],
    tipo_registro: 'todos'
  },
  {
    codigo: 'CT',
    descricao: 'PROCEDIMENTO DE CERTIFICAÇÃO ELETRÔNICA DE UNIÃO ESTÁVEL',
    codigosCusta: [21],
    tipo_registro: 'todos'
  },
  {
    codigo: 'RB',
    descricao: 'ALTERAÇÃO DE REGIME DE BENS NO REGISTRO DE UNIÃO ESTÁVEL',
    codigosCusta: [22],
    tipo_registro: 'todos'
  },
]

export function getAtos () {
  const atos = tipoAtos.filter((item) => {
    if (item.codigo !== 'XC' && item.codigo !== 'XA') return item
  })

  return atos
}

export function getAtoCancelamento () {
  const cancelamento = tipoAtos.find((item) => {
    if (item.codigo === 'XC') return item
  })

  return cancelamento
}

export function getAtoExclusao () {
  const exclusao = tipoAtos.find((item) => {
    if (item.codigo === 'XA') return item
  })

  return exclusao
}

export function getAtosByCodigoCusta (codigoCusta) {
  const atos = tipoAtos.filter((ato) => {
    const indexAto = ato.codigosCusta.indexOf(codigoCusta)

    if (indexAto >= 0) {
      return ato
    }
  })

  return atos
}

export function getDescricaoAtoByCodigo (codigo) {
  const ato = tipoAtos.find(ato => ato.codigo === codigo)

  return ato.descricao
}
